import * as YouTubeIframeLoader from 'youtube-iframe';
import {bodyLock, bodyUnlock} from '../helpers/bodyLock';
import * as Player from "@vimeo/player/dist/player.js";

export class Modal {
    modal: any;
    modalElement: HTMLElement;
    video?: any;
    bodyStyles: string;

    constructor(modalElement: HTMLElement) {
        initializeDialog(modalElement);
    }

    initVideo() {
        const video = this.modalElement.querySelector('iframe');
        if (video) {
            let videoType = this.videoType;
            if (videoType === 'vimeo') {
                this.vimeoInit();
            } else if (videoType === 'youtube') {
                this.youtubeInit();
            }
        } else {
            this.nativeVideoInit();
        }
    }

    nativeVideoInit() {
        let videoElement = this.modalElement.querySelector('video');
        if (videoElement) {
            let videoSource = videoElement.querySelector('source');
            if (!videoSource.src) {
                videoSource.src = videoSource.getAttribute('data-src');
                videoElement.load();
            }
            this.video = videoElement;
        }
    }

    youtubeInit() {
        const youtubeIframe = this.modalElement.querySelector('iframe');
        if (!youtubeIframe.src) {
            const uniqueID = this.modalElement.id;
            YouTubeIframeLoader.load(YT => {
                const playerID = `youtube-player-${uniqueID}`;
                youtubeIframe.id = playerID;
                youtubeIframe.src = youtubeIframe.getAttribute('data-src');
                this.video = new YT.Player(playerID, {});
            });
        }
    }

    vimeoInit() {
        let vimeoIframe = this.modalElement.querySelector('iframe');
        if (!vimeoIframe.src) {
            vimeoIframe.src = vimeoIframe.getAttribute('data-src');
            let vimeoPlayer = new Player(vimeoIframe, {});
            vimeoPlayer.on('loaded', this.playVideo.bind(this));
            this.video = vimeoPlayer;
        } else {
            this.playVideo();
        }
    }

    playVideo() {
        let videoContainer = this.modalElement.querySelector('[data-video-type]');
        if (videoContainer.getAttribute('data-video-type') == 'vimeo') {
            this.video.play();
        } else {
            this.video.play();
        }
    }

    pauseVideo() {
        let videoType = this.videoType;

        if (videoType === 'vimeo') {
            this.video.pause();
        } else if (videoType === 'youtube') {
            this.video.pauseVideo();
        } else {
            if (!this.video.paused) {
                this.video.pause();
            }
        }
    }

    get videoType() {
        let videoContainer = this.modalElement.querySelector('[data-video-type]');
        if (videoContainer) {
            if (videoContainer.getAttribute('data-video-type') == 'vimeo') {
                return 'vimeo';
            } else if (videoContainer.getAttribute('data-video-type') == 'youtube') {
                return 'youtube';
            }
        }
        return '';
    }
}

async function initializeDialog(e: HTMLElement) {
    const {default: A11yDialog} = await import('a11y-dialog');

    this.modal = new A11yDialog(e);
    this.modalElement = e;
    this.modal.on('show', () => {
        this.bodyStyles = bodyLock();
        this.initVideo();
    });
    this.modal.on('hide', () => {
        bodyUnlock(this.bodyStyles);
        if (this.video) {
            this.pauseVideo();
        }
    });
}
